import { IFieldLangMap } from '@pharmsnap/shared/types'

export const LITERATURE_DISCIPLINE_CATEGORY: IFieldLangMap = {
  医学: {
    cn: '医学',
    en: 'MEDICINE',
    jp: '医学',
  },
  生物学: {
    cn: '生物学',
    en: 'BIOLOGY',
    jp: '生物学',
  },
  工程技术: {
    cn: '工程技术',
    en: 'ENGINEERING & TECHNOLOGY',
    jp: '工学・技術',
  },
  法学: {
    cn: '法学',
    en: 'LAW',
    jp: '法学',
  },
  心理学: {
    cn: '心理学',
    en: 'PSYCHOLOGY',
    jp: '心理学',
  },
  农林科学: {
    cn: '农林科学',
    en: 'AGRICULTURAL & FORESTRY SCIENCE',
    jp: '農林科学',
  },
  计算机科学: {
    cn: '计算机科学',
    en: 'COMPUTER SCIENCE',
    jp: 'コンピュータサイエンス',
  },
  化学: {
    cn: '化学',
    en: 'CHEMISTRY',
    jp: '化学',
  },
  环境科学与生态学: {
    cn: '环境科学与生态学',
    en: 'ENVIRONMENTAL SCIENCE & ECOLOGY',
    jp: '環境科学・生態学',
  },
  人文科学: {
    cn: '人文科学',
    en: 'HUMANITIES',
    jp: '人文科学',
  },
  数学: {
    cn: '数学',
    en: 'MATHEMATICS',
    jp: '数学',
  },
  经济学: {
    cn: '经济学',
    en: 'ECONOMICS',
    jp: '経済学',
  },
  地球科学: {
    cn: '地球科学',
    en: 'EARTH SCIENCE',
    jp: '地球科学',
  },
  材料科学: {
    cn: '材料科学',
    en: 'MATERIALS SCIENCE',
    jp: '材料科学',
  },
  物理与天体物理: {
    cn: '物理与天体物理',
    en: 'PHYSICS & ASTROPHYSICS',
    jp: '物理学・天体物理学',
  },
  教育学: {
    cn: '教育学',
    en: 'EDUCATION',
    jp: '教育学',
  },
  管理学: {
    cn: '管理学',
    en: 'MANAGEMENT',
    jp: '経営学',
  },
  综合性期刊: {
    cn: '综合性期刊',
    en: 'CROSS-FIELD',
    jp: '総合誌',
  },
}
